/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React, {Fragment, useEffect} from 'react';
import {Col, FormControl, Row} from 'react-bootstrap';

import {usePrimeCache} from "../../../../Hooks/ServiceHooks";
import {service as SpeciesRequestStatusService} from "../../../../Services/SpeciesRequestStatusService";
import {service as UserService} from '../../../../Services/UserService';
import {LastModifiedSpeciesLabel} from "../Common/SpeciesTable/LastModifiedSpeciesLabel";

export const SpeciesRequestTableFilter = props => {
    const {
        Data,
        UpdateFilters: updateFilters = null,
        OnEditClick,
        filterValues,
        setFilterValue
    } = props;

    usePrimeCache([
        SpeciesRequestStatusService,
    ]);

    const statuses = SpeciesRequestStatusService.CachedValues()?.result ?? [];

    const {
        speciesRequestStatusId = null,
        textFilter = ''
    } = filterValues;

    const textFilterUppercase = textFilter?.toUpperCase?.();

    const filters = [
        {
            code: 'textFilter',
            isSet: textFilterUppercase !== "",
            logic:  x => x?.commonName?.toUpperCase?.().includes(textFilterUppercase) ||
                x?.latinName?.toUpperCase?.().includes(textFilterUppercase) ||
                x?.latinName?.toUpperCase?.().includes(textFilterUppercase) ||
                UserService.CachedTitleById(x?.SpeciesRequest?.requestedByUserId)?.toUpperCase?.().includes(textFilterUppercase) ||
                SpeciesRequestStatusService.CachedTitleById(x?.SpeciesRequest?.speciesRequestStatusId)?.toUpperCase?.().includes(textFilterUppercase)
        },
        {
            code: "speciesRequestStatusId",
            isSet: !!speciesRequestStatusId,
            logic: x => Number(x?.SpeciesRequest?.speciesRequestStatusId) === Number(speciesRequestStatusId)
        }
    ];

    useEffect(() => {
        updateFilters?.(filters);
    }, [textFilter, speciesRequestStatusId]);

    return <Fragment>
        <Col md={6} sm={12} xs={12}>
            <LastModifiedSpeciesLabel 
                modifiedField="reviewed"
                modifiedByUserIdField="reviewedByUserId"
                label="Last Reviewed at"
                data={Data?.map(a => a?.SpeciesRequest)?.filter?.(Boolean)} 
                onDateClick={(id) => OnEditClick(id)} />
        </Col>
        <Col md={6} sm={12} xs={12}>
            <Row className="justify-content-end">
                <Col xs={6} className="d-flex align-items-center">
                    <FormControl
                        as="select"
                        type="text"
                        value={speciesRequestStatusId ?? ""}
                        placeholder="Status"
                        onChange={event => setFilterValue('speciesRequestStatusId', event.target.value)}
                    >
                        <option value={""}>Status</option>
                        {
                            statuses.map(x =>
                                <option key={x.speciesRequestStatusId} value={x.speciesRequestStatusId}>
                                    {x.name}
                                </option>
                            )
                        }
                    </FormControl>
                </Col>
                <Col xs={6} className="d-flex align-items-center">
                    <FormControl
                        type="text"
                        value={textFilter || ""}
                        placeholder="Search Names"
                        onChange={event => setFilterValue('textFilter', event.target.value)}
                    />
                </Col>
            </Row>
            <Row/>
        </Col>
    </Fragment>;
};
